import { useEffect } from 'react';
import {
  createRippleEffectRelative,
  getContentType,
} from '../../../Utils/helper';
import {
  DateCalculateBtn,
  DueDatePregnancyPage,
  LeftColumn,
  RightColumn,
} from '../../PregnancyPage/styled';
import {
  fireClickedCTAEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function CostCalculator(props) {
  const { data, buttonCTA, Deeplink, color } = props;
  const redirectToReactPage = () => {
    window.location.href = Deeplink + window.location.search;
  };
  useEffect(() => {
    fireServedSectionEvent(data?.heading, data?.itemId, getContentType());
  }, []);

  return (
    <>
      <DueDatePregnancyPage backgroundColor={color}>
        <LeftColumn>
          <h4> {data?.heading}</h4>
          <p>{data?.subHeading}</p>
        </LeftColumn>
        <RightColumn costCalculator>
          {/* <Link
                        href={{
                            pathname: Deeplink,
                            query: removeDefaultParams(router.query),
                        }}
                        passHref
                    >
                        <a> */}
          <DateCalculateBtn
            id="costCalulatorButton"
            onClick={(e) => {
              createRippleEffectRelative(
                e,
                document.getElementById('costCalulatorButton'),
              );
              fireClickedCTAEvent(data?.heading, buttonCTA, getContentType());
              redirectToReactPage();
            }}
          >
            {buttonCTA}
          </DateCalculateBtn>
          {/* </a>
                    </Link> */}
        </RightColumn>
      </DueDatePregnancyPage>
    </>
  );
}
